<h2 mat-dialog-title class="dialog-title">{{ titleTranslationKey | translate: titleInterpolateParams }}</h2>

<mat-dialog-content class="dialog-content">
  <ng-content select="[content]" />
</mat-dialog-content>

<mat-dialog-actions align="end">
  <ng-content select="[actions]" />
</mat-dialog-actions>

<button mat-icon-button [mat-dialog-close]="resultOnClose" [aria-label]="'shared.close' | translate" class="dialog-close-button">
  <mat-icon>close</mat-icon>
</button>
